import React from "react";
import StatusFlowbar from "@/components/layout/StatusFlowbar";

interface BrokerAppStatusFlowbarProps {
  borrowerId: number;
  hideBadge?: boolean;
}

export const BrokerAppStatusFlowbar: React.FC<BrokerAppStatusFlowbarProps> = ({
  borrowerId,
  hideBadge,
}) => <StatusFlowbar borrowerId={borrowerId} hideBadge={hideBadge} />;
